/**
 * starter-pack-quiz.js
 * Personalised Starter Pack — inline quiz engine
 * Module: StarterPackQuiz (IIFE)
 */
(function () {
  'use strict';

  var StarterPackQuiz = {

    // ─── CONFIG ───────────────────────────────────────────────────────────────
    Config: {
      API_ENDPOINT: 'https://lvi88fhcpg.execute-api.ap-southeast-2.amazonaws.com/prod/recommendation/quiz/quick-submission',
      REDIRECT_BASE: '/pages/sp-review',
      MAX_SECONDARY_GOALS: 2,
      ANIMATION_DELAY: 250,

      QUESTIONS: [
        {
          id: 'primary_goal',
          title: 'Which area of your health do you most want to improve?',
          type: 'single-select',
          autoAdvance: true,
          options: [
            { value: 'energy',    label: 'Energy',            icon: '⚡' },
            { value: 'stress',    label: 'Stress',            icon: '🧘' },
            { value: 'sleep',     label: 'Sleep',             icon: '😴' },
            { value: 'immunity',  label: 'Immunity',          icon: '🛡️' },
            { value: 'fitness',   label: 'Fitness',           icon: '💪' },
            { value: 'brain',     label: 'Brain & Focus',     icon: '🧠' },
            { value: 'digestion', label: 'Digestion',         icon: '🌿' },
            { value: 'skin',      label: 'Skin',              icon: '✨' },
            { value: 'hair',      label: 'Hair',              icon: '💇' }
          ]
        },
        {
          id: 'secondary_goals',
          title: 'Anything else?',
          description: 'Select up to 2 additional goals.',
          type: 'multi-select',
          maxSelections: 2,
          exclusiveOption: null,
          autoAdvance: false,
          skipAllowed: true,
          options: [
            { value: 'energy',    label: 'Energy',        icon: '⚡' },
            { value: 'stress',    label: 'Stress',        icon: '🧘' },
            { value: 'sleep',     label: 'Sleep',         icon: '😴' },
            { value: 'immunity',  label: 'Immunity',      icon: '🛡️' },
            { value: 'fitness',   label: 'Fitness',       icon: '💪' },
            { value: 'brain',     label: 'Brain & Focus', icon: '🧠' },
            { value: 'digestion', label: 'Digestion',     icon: '🌿' },
            { value: 'skin',      label: 'Skin',          icon: '✨' },
            { value: 'hair',      label: 'Hair',          icon: '💇' },
            { value: 'heart',     label: 'Heart',         icon: '❤️' },
            { value: 'joints',    label: 'Joints',        icon: '🦵' },
            { value: 'bones',     label: 'Bones',         icon: '🦴' }
          ]
        },
        {
          id: 'age_range',
          title: 'What is your age range?',
          type: 'single-select',
          autoAdvance: true,
          options: [
            { value: '18-24', label: '18–24' },
            { value: '25-34', label: '25–34' },
            { value: '35-44', label: '35–44' },
            { value: '45-54', label: '45–54' },
            { value: '55+',   label: '55+' }
          ]
        },
        {
          id: 'gender',
          title: 'What sex were you assigned at birth?',
          description: 'We appreciate this might not align with your gender identity.',
          type: 'single-select',
          autoAdvance: true,
          options: [
            { value: 'female', label: 'Female' },
            { value: 'male',   label: 'Male' },
            { value: 'none',   label: 'Prefer not to say' }
          ]
        },
        {
          id: 'pregnancy',
          title: 'Are you currently trying, pregnant or recently given birth?',
          type: 'single-select',
          autoAdvance: true,
          conditional: { questionId: 'gender', operator: 'not_equals', value: 'male' },
          options: [
            { value: 'trying',        label: "I'm trying for a baby" },
            { value: 'pregnant',      label: "I'm pregnant" },
            { value: 'breastfeeding', label: "I'm breastfeeding" },
            { value: 'no',            label: 'None of these' }
          ]
        },
        {
          id: 'describe_diets',
          title: 'How would you describe your diet?',
          type: 'single-select',
          autoAdvance: true,
          options: [
            { value: 'any',         label: 'I eat almost everything!' },
            { value: 'plant_based', label: 'Prefer plant-based foods' },
            { value: 'vegetarian',  label: 'Vegetarian' },
            { value: 'vegan',       label: 'Vegan' },
            { value: 'other',       label: 'Other' }
          ]
        },
        {
          id: 'allergy',
          title: 'Are you allergic to any of the following?',
          description: 'Select all that apply',
          type: 'multi-select',
          maxSelections: null,
          exclusiveOption: 'none',
          autoAdvance: false,
          gridLayout: true,
          // Values match Quiz V2 canonical values and Shopify remove_criteria
          options: [
            { value: 'none',      label: 'None of these', exclusive: true },
            { value: 'fish',      label: 'Fish' },
            { value: 'gluten',    label: 'Gluten' },
            { value: 'lactose',   label: 'Milk' },
            { value: 'soy',       label: 'Soy' },
            { value: 'sulphites', label: 'Sulphites' },
            { value: 'yeast',     label: 'Yeast' },
            { value: 'treenut',   label: 'Tree nuts' },
            { value: 'peanut',    label: 'Peanuts' },
            { value: 'egg',       label: 'Egg' },
            { value: 'sesame',    label: 'Sesame' }
          ]
        },
        {
          id: 'routine_answers',
          title: 'Do any of these apply to your daily routine?',
          description: 'Select all that apply',
          type: 'multi-question-page',
          skipAllowed: true,
          options: [
            { label: 'I get less than 20 mins of sunshine',                         questionKey: 'sunshine',          value: 'rarely' },
            { label: 'I eat less than 1\u20132 serves of fruit and vegetables', questionKey: 'fruit_vegetables',  value: 'none' },
            { label: 'I smoke or vape regularly',                                   questionKey: 'smoke',             value: 'frequently' },
            { label: 'My doctor has recommended that I take iron',                  questionKey: 'iron',              value: 'yes' }
          ]
        },
        {
          id: 'email',
          title: 'Almost there!',
          description: 'Save your pack in case you want it later',
          type: 'email',
          autoAdvance: false,
          placeholder: 'your@email.com',
          ctaLabel: 'Reveal My Pack →',
          consentCheckbox: {
            id: 'email_marketing_consent',
            label: 'By checking this box, you confirm that you have read and agreed to our <a href="https://vitable.com.au/policies/privacy-policy" target="_blank" rel="noopener noreferrer">Privacy Policy</a>. By choosing \u2018Reveal My Pack\u2019, you also consent to receiving our communications and exclusive offers and can unsubscribe at any time.',
            defaultChecked: false,
            required: true
          },
          validation: {
            required: true,
            pattern: /^[^\s@]+@[^\s@]+\.[^\s@]+$/
          }
        }
      ]
    },

    // ─── STATE ────────────────────────────────────────────────────────────────
    State: {
      currentStep: 0,              // 0 = landing, 1+ = question index (1-based)
      answers: {},                 // { questionId: value | [values] }
      email: '',
      emailMarketingConsent: false,
      submitting: false,
      utmParams: {},

      reset: function () {
        this.currentStep = 0;
        this.answers = {};
        this.email = '';
        this.emailMarketingConsent = false;
        this.submitting = false;
      },

      getVisibleQuestions: function () {
        return StarterPackQuiz.Config.QUESTIONS.filter(function (q) {
          if (!q.conditional) return true;
          var dep = q.conditional;
          var answer = StarterPackQuiz.State.answers[dep.questionId];
          if (dep.operator === 'not_equals') return answer !== dep.value;
          if (dep.operator === 'equals') return answer === dep.value;
          return true;
        });
      },

      getTotalSteps: function () {
        return this.getVisibleQuestions().length;
      }
    },

    // ─── LANDING ──────────────────────────────────────────────────────────────
    Landing: {
      init: function () {
        var startBtn = document.getElementById('sp-quiz-start-btn');
        if (startBtn) {
          startBtn.addEventListener('click', this.handleStart.bind(this));
        }
      },

      handleStart: function () {
        var landing = document.getElementById('sp-quiz-landing');
        var quizSection = document.getElementById('sp-quiz-section');
        if (landing) landing.hidden = true;
        if (quizSection) quizSection.hidden = false;

        StarterPackQuiz.State.currentStep = 1;
        StarterPackQuiz.Renderer.render();
        StarterPackQuiz.Analytics.quizStarted();
      }
    },

    // ─── RENDERER ─────────────────────────────────────────────────────────────
    Renderer: {
      render: function () {
        var questions = StarterPackQuiz.State.getVisibleQuestions();
        var idx = StarterPackQuiz.State.currentStep - 1;
        var question = questions[idx];
        if (!question) return;

        this.updateProgress(StarterPackQuiz.State.currentStep, questions.length);

        var body = document.getElementById('sp-quiz-body');
        if (!body) return;
        body.innerHTML = '';

        var fragment;
        if (question.type === 'single-select') {
          fragment = this.renderSingleSelect(question);
        } else if (question.type === 'multi-select') {
          fragment = this.renderMultiSelect(question);
        } else if (question.type === 'multi-question-page') {
          fragment = this.renderMultiQuestionPage(question);
        } else if (question.type === 'email') {
          fragment = this.renderEmail(question);
        }

        if (fragment) body.appendChild(fragment);

        // Scroll to top of quiz on question change
        body.scrollTop = 0;
        window.scrollTo({ top: 0, behavior: 'smooth' });
      },

      updateProgress: function (current, total) {
        var bar = document.getElementById('sp-quiz-progress-bar');
        var container = document.getElementById('sp-quiz-progress');
        var pct = Math.max(0, Math.min(100, total > 0 ? Math.round((current / total) * 100) : 0));

        if (container) {
          container.style.setProperty('--sp-progress-width', pct + '%');
          container.style.setProperty('--sp-progress-min-width', pct > 0 ? '18px' : '0px');
          container.setAttribute('aria-valuenow', pct);
        }

        if (bar) {
          bar.style.width = pct + '%';
        }
        var counter = document.getElementById('sp-quiz-step-counter');
        if (counter) counter.style.display = 'none';

        // Hide back button on first question (keep in layout to prevent height jump)
        var backBtn = document.getElementById('sp-quiz-back-btn');
        var quizHeader = document.querySelector('.sp-quiz__quiz-header');
        var hasBack = current > 1;
        if (backBtn) {
          backBtn.classList.toggle('sp-quiz__back-btn--hidden', !hasBack);
        }
        if (quizHeader) {
          quizHeader.classList.toggle('sp-quiz__quiz-header--has-back', hasBack);
        }
      },

      renderSingleSelect: function (question) {
        var container = document.createElement('div');
        container.className = 'sp-quiz__question';

        var title = document.createElement('h2');
        title.className = 'sp-quiz__question-title';
        title.textContent = question.title;
        container.appendChild(title);

        if (question.description) {
          var desc = document.createElement('p');
          desc.className = 'sp-quiz__question-desc';
          desc.textContent = question.description;
          container.appendChild(desc);
        }

        var optionsList = document.createElement('div');
        optionsList.className = 'sp-quiz__options';

        question.options.forEach(function (opt) {
          var optEl = document.createElement('button');
          optEl.type = 'button';
          optEl.className = 'sp-quiz__option';

          if (StarterPackQuiz.State.answers[question.id] === opt.value) {
            optEl.classList.add('sp-quiz__option--selected');
          }

          if (opt.icon) {
            var icon = document.createElement('span');
            icon.className = 'sp-quiz__option-icon';
            icon.setAttribute('aria-hidden', 'true');
            icon.textContent = opt.icon;
            optEl.appendChild(icon);
          }

          var label = document.createElement('span');
          label.className = 'sp-quiz__option-label';
          label.textContent = opt.label;
          optEl.appendChild(label);

          var check = document.createElement('span');
          check.className = 'sp-quiz__option-check';
          check.setAttribute('aria-hidden', 'true');
          optEl.appendChild(check);

          optEl.addEventListener('click', function () {
            optionsList.querySelectorAll('.sp-quiz__option').forEach(function (el) {
              el.classList.remove('sp-quiz__option--selected');
            });
            optEl.classList.add('sp-quiz__option--selected');
            StarterPackQuiz.State.answers[question.id] = opt.value;

            if (question.autoAdvance) {
              setTimeout(function () {
                StarterPackQuiz.Navigation.next();
              }, StarterPackQuiz.Config.ANIMATION_DELAY);
            }
          });

          optionsList.appendChild(optEl);
        });

        container.appendChild(optionsList);
        return container;
      },

      renderMultiSelect: function (question) {
        var container = document.createElement('div');
        container.className = 'sp-quiz__question';

        var title = document.createElement('h2');
        title.className = 'sp-quiz__question-title';
        title.textContent = question.title;
        container.appendChild(title);

        if (question.description) {
          var desc = document.createElement('p');
          desc.className = 'sp-quiz__question-desc';
          desc.textContent = question.description;
          container.appendChild(desc);
        }

        var optionsList = document.createElement('div');
        optionsList.className = 'sp-quiz__options' + (question.gridLayout ? ' sp-quiz__options--grid' : '');

        var currentSelections = (StarterPackQuiz.State.answers[question.id] || []).slice();

        // For secondary_goals: filter out the already-selected primary goal
        var filteredOptions = question.options;
        if (question.id === 'secondary_goals') {
          var primaryGoal = StarterPackQuiz.State.answers['primary_goal'];
          if (primaryGoal) {
            filteredOptions = question.options.filter(function (opt) {
              return opt.value !== primaryGoal;
            });
          }
        }

        filteredOptions.forEach(function (opt) {
          var optEl = document.createElement('button');
          optEl.type = 'button';
          optEl.className = 'sp-quiz__option sp-quiz__option--multi';
          if (opt.exclusive && question.gridLayout) {
            optEl.classList.add('sp-quiz__option--full-width');
          }

          if (currentSelections.indexOf(opt.value) > -1) {
            optEl.classList.add('sp-quiz__option--selected');
          }

          if (opt.icon) {
            var icon = document.createElement('span');
            icon.className = 'sp-quiz__option-icon';
            icon.setAttribute('aria-hidden', 'true');
            icon.textContent = opt.icon;
            optEl.appendChild(icon);
          }

          var label = document.createElement('span');
          label.className = 'sp-quiz__option-label';
          label.textContent = opt.label;
          optEl.appendChild(label);

          var check = document.createElement('span');
          check.className = 'sp-quiz__option-check';
          check.setAttribute('aria-hidden', 'true');
          optEl.appendChild(check);

          optEl.addEventListener('click', function () {
            var selections = (StarterPackQuiz.State.answers[question.id] || []).slice();

            if (opt.exclusive) {
              // Exclusive: deselect all others
              selections = [opt.value];
              optionsList.querySelectorAll('.sp-quiz__option').forEach(function (el) {
                el.classList.remove('sp-quiz__option--selected');
              });
              optEl.classList.add('sp-quiz__option--selected');
            } else {
              // Remove exclusive option if present
              if (question.exclusiveOption) {
                var exclusiveIdx = selections.indexOf(question.exclusiveOption);
                if (exclusiveIdx > -1) {
                  selections.splice(exclusiveIdx, 1);
                  optionsList.querySelectorAll('.sp-quiz__option').forEach(function (el) {
                    el.classList.remove('sp-quiz__option--selected');
                  });
                }
              }

              var itemIdx = selections.indexOf(opt.value);
              if (itemIdx > -1) {
                selections.splice(itemIdx, 1);
                optEl.classList.remove('sp-quiz__option--selected');
              } else {
                if (question.maxSelections && selections.length >= question.maxSelections) {
                  return; // at limit
                }
                selections.push(opt.value);
                optEl.classList.add('sp-quiz__option--selected');
              }
            }

            StarterPackQuiz.State.answers[question.id] = selections;

            // Update next button text and state
            var nextBtn = container.querySelector('.sp-quiz__next-btn');
            if (nextBtn) {
              if (question.skipAllowed) {
                nextBtn.innerHTML = selections.length > 0
                  ? 'Next \u2192'
                  : 'Skip \u2192';
                nextBtn.classList.toggle('sp-quiz__next-btn--sticky', selections.length > 0);
                nextBtn.disabled = false;
              } else {
                nextBtn.disabled = selections.length === 0;
                nextBtn.classList.toggle('sp-quiz__next-btn--sticky', selections.length > 0);
              }
            }
          });

          optionsList.appendChild(optEl);
        });

        container.appendChild(optionsList);

        var nextBtn = document.createElement('button');
        nextBtn.type = 'button';
        nextBtn.className = 'sp-quiz__next-btn';

        if (question.skipAllowed) {
          // Show "Skip" by default, changes to "Next" when selections made
          var hasSelections = currentSelections.length > 0;
          nextBtn.innerHTML = (hasSelections ? 'Next' : 'Skip') + ' \u2192';
          nextBtn.disabled = false;
          if (hasSelections) nextBtn.classList.add('sp-quiz__next-btn--sticky');
        } else {
          nextBtn.innerHTML = 'Next \u2192';
          nextBtn.disabled = currentSelections.length === 0;
          if (currentSelections.length > 0) nextBtn.classList.add('sp-quiz__next-btn--sticky');
        }

        nextBtn.addEventListener('click', function () {
          StarterPackQuiz.Navigation.next();
        });
        container.appendChild(nextBtn);

        return container;
      },

      renderMultiQuestionPage: function (question) {
        var container = document.createElement('div');
        container.className = 'sp-quiz__question';

        var title = document.createElement('h2');
        title.className = 'sp-quiz__question-title';
        title.textContent = question.title;
        container.appendChild(title);

        if (question.description) {
          var desc = document.createElement('p');
          desc.className = 'sp-quiz__question-desc';
          desc.textContent = question.description;
          container.appendChild(desc);
        }

        var optionsList = document.createElement('div');
        optionsList.className = 'sp-quiz__options';

        var currentAnswers = StarterPackQuiz.State.answers[question.id] || {};

        question.options.forEach(function (opt) {
          var optEl = document.createElement('button');
          optEl.type = 'button';
          optEl.className = 'sp-quiz__option sp-quiz__option--multi sp-quiz__option--sentence-case';

          if (currentAnswers[opt.questionKey] === opt.value) {
            optEl.classList.add('sp-quiz__option--selected');
          }

          var label = document.createElement('span');
          label.className = 'sp-quiz__option-label';
          label.textContent = opt.label;
          optEl.appendChild(label);

          var check = document.createElement('span');
          check.className = 'sp-quiz__option-check';
          check.setAttribute('aria-hidden', 'true');
          optEl.appendChild(check);

          optEl.addEventListener('click', function () {
            var answers = StarterPackQuiz.State.answers[question.id];
            if (!answers || typeof answers !== 'object' || Array.isArray(answers)) {
              answers = {};
            }

            if (answers[opt.questionKey] === opt.value) {
              delete answers[opt.questionKey];
              optEl.classList.remove('sp-quiz__option--selected');
            } else {
              answers[opt.questionKey] = opt.value;
              optEl.classList.add('sp-quiz__option--selected');
            }

            StarterPackQuiz.State.answers[question.id] = answers;

            var selectionCount = Object.keys(answers).length;
            var nextBtn = container.querySelector('.sp-quiz__next-btn');
            if (nextBtn) {
              nextBtn.innerHTML = (selectionCount > 0 ? 'Next' : 'Skip') + ' \u2192';
              nextBtn.classList.toggle('sp-quiz__next-btn--sticky', selectionCount > 0);
            }
          });

          optionsList.appendChild(optEl);
        });

        container.appendChild(optionsList);

        var selectionCount = Object.keys(currentAnswers).length;
        var nextBtn = document.createElement('button');
        nextBtn.type = 'button';
        nextBtn.className = 'sp-quiz__next-btn';
        nextBtn.innerHTML = (selectionCount > 0 ? 'Next' : 'Skip') + ' \u2192';
        nextBtn.disabled = false;
        if (selectionCount > 0) nextBtn.classList.add('sp-quiz__next-btn--sticky');

        nextBtn.addEventListener('click', function () {
          StarterPackQuiz.Navigation.next();
        });
        container.appendChild(nextBtn);

        return container;
      },

      renderEmail: function (question) {
        var container = document.createElement('div');
        container.className = 'sp-quiz__question sp-quiz__question--email';

        // Centered icon
        var iconWrap = document.createElement('div');
        iconWrap.style.cssText = 'text-align: center; margin-bottom: 16px;';
        var iconCircle = document.createElement('div');
        iconCircle.style.cssText = 'width: 48px; height: 48px; border-radius: 50%; background: var(--sp-color-beige); display: flex; align-items: center; justify-content: center; margin: 0 auto;';
        iconCircle.innerHTML = '<span style="font-size: 20px; color: var(--sp-color-sage);">✉</span>';
        iconWrap.appendChild(iconCircle);
        container.appendChild(iconWrap);

        var title = document.createElement('h2');
        title.className = 'sp-quiz__question-title';
        title.textContent = question.title;
        container.appendChild(title);

        if (question.description) {
          var desc = document.createElement('p');
          desc.className = 'sp-quiz__question-desc';
          desc.textContent = question.description;
          container.appendChild(desc);
        }

        var emailWrapper = document.createElement('div');
        emailWrapper.className = 'sp-quiz__email-wrapper';

        var input = document.createElement('input');
        input.type = 'email';
        input.className = 'sp-quiz__email-input';
        input.placeholder = question.placeholder;
        input.autocomplete = 'email';
        input.setAttribute('inputmode', 'email');
        input.value = StarterPackQuiz.State.email;
        emailWrapper.appendChild(input);

        var errorEl = document.createElement('p');
        errorEl.className = 'sp-quiz__email-error';
        errorEl.setAttribute('role', 'alert');
        errorEl.textContent = 'Please enter a valid email address';
        emailWrapper.appendChild(errorEl);

        container.appendChild(emailWrapper);

        // Consent checkbox (optional)
        var consent = question.consentCheckbox;
        var consentWrapper = document.createElement('label');
        consentWrapper.className = 'sp-quiz__consent';

        var checkbox = document.createElement('input');
        checkbox.type = 'checkbox';
        checkbox.id = consent.id;
        checkbox.className = 'sp-quiz__consent-checkbox';
        checkbox.checked = StarterPackQuiz.State.emailMarketingConsent;
        consentWrapper.appendChild(checkbox);

        var consentLabel = document.createElement('span');
        consentLabel.className = 'sp-quiz__consent-label';
        consentLabel.innerHTML = consent.label;
        consentWrapper.appendChild(consentLabel);

        container.appendChild(consentWrapper);

        var consentError = document.createElement('p');
        consentError.className = 'sp-quiz__email-error';
        consentError.textContent = 'Please agree to the Privacy Policy to continue.';
        container.appendChild(consentError);

        var submitBtn = document.createElement('button');
        submitBtn.type = 'button';
        submitBtn.className = 'sp-quiz__next-btn';
        submitBtn.innerHTML = question.ctaLabel;
        submitBtn.disabled = !StarterPackQuiz.State.email;

        var submitError = document.createElement('p');
        submitError.className = 'sp-quiz__submit-error';
        submitError.setAttribute('role', 'alert');

        input.addEventListener('input', function () {
          StarterPackQuiz.State.email = input.value.trim();
          submitBtn.disabled = !StarterPackQuiz.State.email;
          input.classList.remove('sp-quiz__email-input--error');
          errorEl.classList.remove('sp-quiz__email-error--visible');
        });

        checkbox.addEventListener('change', function () {
          StarterPackQuiz.State.emailMarketingConsent = checkbox.checked;
          if (checkbox.checked) {
            consentError.classList.remove('sp-quiz__email-error--visible');
          }
        });

        submitBtn.addEventListener('click', function () {
          var email = StarterPackQuiz.State.email;
          if (!question.validation.pattern.test(email)) {
            input.classList.add('sp-quiz__email-input--error');
            errorEl.classList.add('sp-quiz__email-error--visible');
            return;
          }
          if (consent.required && !checkbox.checked) {
            consentError.classList.add('sp-quiz__email-error--visible');
            return;
          }
          StarterPackQuiz.Submit.submit();
        });

        input.addEventListener('keydown', function (e) {
          if (e.key === 'Enter') {
            e.preventDefault();
            submitBtn.click();
          }
        });

        container.appendChild(submitBtn);
        container.appendChild(submitError);

        // Medical disclaimer
        var disclaimer = document.createElement('p');
        disclaimer.className = 'sp-quiz__disclaimer';
        disclaimer.textContent = 'This service does not provide medical advice and is not intended to diagnose, treat, cure or prevent any disease. Some medicines may not be right for you. Read the label and any warnings before purchase. If you have any pre-existing conditions, or are on any medications, always talk to your health professional before use.';
        container.appendChild(disclaimer);

        return container;
      }
    },

    // ─── NAVIGATION ───────────────────────────────────────────────────────────
    Navigation: {
      init: function () {
        var backBtn = document.getElementById('sp-quiz-back-btn');
        if (backBtn) {
          backBtn.addEventListener('click', this.back.bind(this));
        }
      },

      next: function () {
        var questions = StarterPackQuiz.State.getVisibleQuestions();
        var currentIdx = StarterPackQuiz.State.currentStep - 1;
        var currentQuestion = questions[currentIdx];

        // Validate current question has an answer (skip validation if skipAllowed)
        if (currentQuestion && currentQuestion.type !== 'email' && !currentQuestion.skipAllowed) {
          var answer = StarterPackQuiz.State.answers[currentQuestion.id];
          if (!answer || (Array.isArray(answer) && answer.length === 0)) {
            return;
          }
        }

        if (StarterPackQuiz.State.currentStep >= questions.length) {
          return;
        }

        // Fire analytics before advancing
        if (currentQuestion) {
          StarterPackQuiz.Analytics.questionAnswered(
            currentQuestion.id,
            StarterPackQuiz.State.answers[currentQuestion.id]
          );
        }

        StarterPackQuiz.State.currentStep++;
        StarterPackQuiz.Renderer.render();
      },

      back: function () {
        if (StarterPackQuiz.State.currentStep <= 1) {
          var landing = document.getElementById('sp-quiz-landing');
          var quizSection = document.getElementById('sp-quiz-section');
          if (landing) landing.hidden = false;
          if (quizSection) quizSection.hidden = true;
          StarterPackQuiz.State.currentStep = 0;
          return;
        }

        StarterPackQuiz.State.currentStep--;

        var questions = StarterPackQuiz.State.getVisibleQuestions();
        if (StarterPackQuiz.State.currentStep > questions.length) {
          StarterPackQuiz.State.currentStep = questions.length;
        }

        StarterPackQuiz.Renderer.render();
      }
    },

    // ─── SUBMIT ───────────────────────────────────────────────────────────────
    Submit: {
      submit: function () {
        if (StarterPackQuiz.State.submitting) return;
        StarterPackQuiz.State.submitting = true;

        var loading = document.getElementById('sp-quiz-loading');
        if (loading) loading.hidden = false;

        var payload = this.buildPayload();
        this.sendRequest(payload, 0);
      },

      buildPayload: function () {
        var state = StarterPackQuiz.State;
        var answers = state.answers;

        // Merge primary + secondary goals
        var goals = [answers.primary_goal];
        if (Array.isArray(answers.secondary_goals)) {
          var secondary = answers.secondary_goals.filter(function (g) { return g !== 'none'; });
          goals = goals.concat(secondary);
        }

        // Normalize allergies (convert ['none'] → [])
        var allergies = answers.allergy || ['none'];
        if (allergies.indexOf('none') > -1) allergies = [];

        // Convert routine_answers object to additional_answers array
        var routineObj = answers.routine_answers || {};
        var additionalAnswers = [];
        Object.keys(routineObj).forEach(function (key) {
          additionalAnswers.push({ question_short: key, response: routineObj[key] });
        });

        var utm = state.utmParams || {};

        return {
          email: state.email,
          email_marketing_consent: state.emailMarketingConsent,
          primary_goal: goals[0],
          secondary_goals: goals.slice(1),
          gender: answers.gender,
          age_range: answers.age_range,
          pregnancy: answers.pregnancy || 'no',
          describe_diets: answers.describe_diets,
          allergy: allergies,
          additional_answers: additionalAnswers,
          quiz_mode: 'quick_pack',
          quiz_source: 'starter_pack',
          utm_source: utm.utm_source || '',
          utm_medium: utm.utm_medium || '',
          utm_campaign: utm.utm_campaign || '',
          utm_content: utm.utm_content || '',
          utm_term: utm.utm_term || '',
          landing_page: window.location.pathname,
          experiment_variant: utm.experiment_variant || ''
        };
      },

      /**
       * Build the final redirect URL from backend response fields.
       * Frontend owns navigation — backend provides token + metadata.
       */
      buildResultRedirectUrl: function (token, resultPagePath) {
        return (resultPagePath || StarterPackQuiz.Config.REDIRECT_BASE) +
          '?token=' + encodeURIComponent(token);
      },

      sendRequest: function (payload, attempt) {
        var self = this;
        var maxAttempts = 2;

        fetch(StarterPackQuiz.Config.API_ENDPOINT, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload)
        })
          .then(function (response) {
            if (!response.ok) throw new Error('HTTP ' + response.status);
            return response.json();
          })
          .then(function (data) {
            var token = data.token;
            if (!token) throw new Error('Missing starter pack token in response');

            // Persist safety values to localStorage (mirrors quiz-v2.js writeLocalStorage)
            try {
              var preg = payload.pregnancy;
              if (preg && preg !== '' && preg !== 'no') {
                localStorage.setItem('vitable_pregnancy', preg);
              } else {
                localStorage.removeItem('vitable_pregnancy');
              }
              var allArr = payload.allergy;
              if (allArr && allArr.length > 0) {
                localStorage.setItem('vitable_allergy', allArr.join(','));
              } else {
                localStorage.removeItem('vitable_allergy');
              }
            } catch (e) { /* localStorage unavailable */ }

            StarterPackQuiz.Analytics.quizSubmitted(payload);

            window.location.href = self.buildResultRedirectUrl(
              token,
              StarterPackQuiz.Config.REDIRECT_BASE
            );
          })
          .catch(function (err) {
            if (attempt < maxAttempts - 1) {
              setTimeout(function () {
                self.sendRequest(payload, attempt + 1);
              }, 1000);
            } else {
              self.handleError(err.message || 'Network error');
            }
          });
      },

      handleError: function (message) {
        StarterPackQuiz.State.submitting = false;

        var loading = document.getElementById('sp-quiz-loading');
        if (loading) loading.hidden = true;

        var body = document.getElementById('sp-quiz-body');
        if (body) {
          // Remove any existing error block
          var existing = body.querySelector('.sp-quiz__error');
          if (existing) existing.remove();

          var errorDiv = document.createElement('div');
          errorDiv.className = 'sp-quiz__error';
          errorDiv.innerHTML =
            '<p class="sp-quiz__error-title">Something went wrong</p>' +
            '<p class="sp-quiz__error-text">Please try again. If the problem persists, refresh the page.</p>' +
            '<button class="sp-quiz__next-btn" type="button">Try Again</button>';

          errorDiv.querySelector('button').addEventListener('click', function () {
            errorDiv.remove();
            StarterPackQuiz.State.submitting = false;
            StarterPackQuiz.Submit.submit();
          });

          body.appendChild(errorDiv);
        }

        console.error('[SP] Submission failed:', message);
      }
    },

    // ─── ANALYTICS ────────────────────────────────────────────────────────────
    Analytics: {
      quizStarted: function () {
        if (typeof gtag === 'function') {
          gtag('event', 'sp_quiz_started', { source: 'starter_pack' });
        }
        if (window.ttq && typeof window.ttq.track === 'function') {
          window.ttq.track('ClickButton', {
            content_type: 'quiz_start',
            content_id: 'starter_pack'
          });
        }
      },

      questionAnswered: function (questionId, answer) {
        // Track progression only — answer values intentionally omitted (health data)
        if (typeof gtag === 'function') {
          gtag('event', 'sp_question_answered', {
            question_id: questionId,
            question_number: StarterPackQuiz.State.currentStep
          });
        }
      },

      quizSubmitted: function (payload) {
        if (typeof gtag === 'function') {
          gtag('event', 'sp_quiz_submitted', {
            goal_count: 1 + (payload.secondary_goals || []).length,
            source: 'starter_pack'
          });
        }
        if (window.ttq && typeof window.ttq.track === 'function') {
          window.ttq.track('SubmitForm', {
            content_type: 'quiz_submission',
            content_id: 'starter_pack',
            description: 'Starter Pack Quiz Submission'
          });
        }
        if (typeof fbq === 'function') {
          fbq('track', 'Lead', {}, { eventID: 'sp_' + Date.now() });
        }
      }
    },

    // ─── INIT ─────────────────────────────────────────────────────────────────
    init: function () {
      var container = document.getElementById('starter-pack-quiz');

      // Capture UTM params + attribution
      try {
        var params = new URLSearchParams(window.location.search);
        StarterPackQuiz.State.utmParams = {
          utm_source:   params.get('utm_source')   || '',
          utm_medium:   params.get('utm_medium')   || '',
          utm_campaign: params.get('utm_campaign') || '',
          utm_content:  params.get('utm_content')  || '',
          utm_term:     params.get('utm_term')     || '',
          ttclid:       params.get('ttclid')       || '',
          experiment_variant: params.get('experiment_variant') || ''
        };
      } catch (e) {
        StarterPackQuiz.State.utmParams = {};
      }

      StarterPackQuiz.Landing.init();
      StarterPackQuiz.Navigation.init();
    }
  };

  // Boot
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { StarterPackQuiz.init(); });
  } else {
    StarterPackQuiz.init();
  }

})();
